import React, { useEffect,useState } from 'react';
  //import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';

import {
  FontFamilies,
  FontSizes,
  Theme,
  MediaQueries,
  Colors,
  isValidEmail,
  Environment,
  Logger,
  resolveResponse,
  resolveRejected,
  isValidProviderResult
} from 'common';

import {
  Button,
  Card,
  Text,
  TextInput,
} from 'common/components';

import {
  withCommon,
} from 'common/hocs';

import PaystackPop from '@paystack/inline-js';
import { wrappedAxios as axios } from 'providers/axios';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${Theme.Content.Background};
  padding: 20px 15px;
  align-items: center;

  @media only screen and ${MediaQueries.Md} {
    padding: 40px 20px;
  }
`;

const ProductContainer = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 0px;

  @media only screen and ${MediaQueries.Md} {
    margin-bottom: 10px;
  }
`;

const ProductCard = styled.div`
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  margin: 0;
  width: 100%;
  
  @media only screen and ${MediaQueries.Md} {
    padding: 30px;
  }
`;

const ProductImage = styled.div`
  width: 100%;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  overflow: hidden;
`;

const VideoIcon = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
  z-index: 1;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 20px 0;
`;

const PriceText = styled(Text)`
  font-size: 2rem;
  font-family: ${FontFamilies.Bold};
  color: ${Colors.PrimaryOne};
`;

const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex-direction: column-reverse;

  @media only screen and ${MediaQueries.Md} {
    flex-direction: row;
  }
`;

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 10px;
  width: 100%;

  @media only screen and ${MediaQueries.Md} {
    padding: 20px;
  }
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #10B981;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
  
  &::after {
    content: '✓';
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
  }
`;

const SuccessButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media only screen and ${MediaQueries.Md} {
    max-width: 200px;
  }
`;

const ProductUI = props => {
  //const { productId, organizerId } = useParams();
  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    gradeOfChildren: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleBuyNow = () => {
    setShowForm(true);
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.firstName.trim()) {
      props.common.showToast('Please enter your first name');
      return;
    }
    if (!formData.lastName.trim()) {
      props.common.showToast('Please enter your last name');
      return;
    }
    if (!formData.email.trim()) {
      props.common.showToast('Please enter your email address');
      return;
    }
    
    // Basic email validation
    if (!isValidEmail(formData.email)) {
      props.common.showToast('Please enter a valid email address');
      return;
    }

    try {
      props.common.showLoading('Processing your order...');
      
      // Create checkout session
      const checkoutRes = await createCheckoutSession();
      
      if (!isValidProviderResult(checkoutRes) || !checkoutRes.data.access_code) {
        throw new Error(checkoutRes.message || 'Unable to create payment session');
      }

      // Initialize Paystack popup
      await initializePaystackPayment(checkoutRes.data.access_code);
      
    } catch (ex) {
      Logger.error('MountainviewProduct', 'handleSubmit', ex);
      props.common.showToast('Oops! Something didn\'t go as planned. Please try again.');
      props.common.hideLoading();
    }
  };

  const createCheckoutSession = async () => {
    try {

      const url = `${Environment.apiHost}payment/mountainview-product-checkout`;
      
      const res = await axios.post(url, {
        email: formData.email,
        firstname: formData.firstName,
        lastname: formData.lastName,
        grade: formData.gradeOfChildren,
        //platform: props.common.platform,
        //productId: productId,
        //organiserId: organizerId
      });

      return resolveResponse(res);
    } catch (ex) {
      return resolveRejected(ex);
    }
  };

  const initializePaystackPayment = async (accessCode) => {
    props.common.showLoading('Preparing your payment...');

    const popup = new PaystackPop();

    if (popup.backgroundIframe?.style) {
      popup.backgroundIframe.style.backgroundColor = 'transparent';
    }
    if (popup.checkoutIframe?.style) {
      popup.checkoutIframe.style.opacity = '0';
    }
    
    popup.resumeTransaction(accessCode, {
      onLoad: (transaction) => {
        if (popup.backgroundIframe?.style) {
          popup.backgroundIframe.style.backgroundColor = '#00000050';
        }
        if (popup.checkoutIframe?.style) {
          popup.checkoutIframe.style.opacity = '1';
        }

        props.common.hideLoading();
      },
      onSuccess: (transaction) => {
        props.common.hideLoading();
        setShowSuccess(true);
        setShowForm(false);
        window.scrollTo(0, 0);
      },
      onError: (error) => {
        Logger.error('MountainviewProduct', 'paymentError', error);
        props.common.hideLoading();
        props.common.showToast('Payment failed. Please try again.');
      },
      onCancel: () => {
        props.common.hideLoading();
        props.common.showToast('Payment cancelled.');
      }
    });
  };

  const handleBack = () => {
    setShowForm(false);
  };

  const handleBackToProduct = () => {
    setShowSuccess(false);
    setShowForm(false);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      gradeOfChildren: ''
    });
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []); 

  return (
    <Container>
      <Text
        maxWidth={'600px'}
        margin={'0 auto'}
        width={'100%'}
        display={'block'} 
        padding={'0 0 15px 0'} 
        fontSize={FontSizes.Small}
        color={Theme.Text.Color}
      >
        <span style={{cursor: 'pointer'}} onClick={() => props.common.navigate('/')}>← Back</span>
      </Text>
      
      <ProductContainer>
        <HeaderContainer>
          <Text
            fontSize="2rem"
            fontFamily={FontFamilies.Bold}
            textAlign="center"
            margin="0 0 10px 0"
          >
            Concert Video
          </Text>
          <Text
            fontSize={FontSizes.Small}
            color="#666"
            textAlign="center"
          >
            High-quality professional recording
          </Text>
        </HeaderContainer>

        <Card>
          <ProductCard>
            {showSuccess ? (
              <SuccessContainer>
                <SuccessIcon />
                
                <Text
                  fontSize={FontSizes.Big}
                  fontFamily={FontFamilies.Bold}
                  margin="0 0 15px 0"
                  color="#10B981"
                >
                  Payment Successful!
                </Text>

                <Text
                  fontSize={FontSizes.Regular}
                  margin="0 0 10px 0"
                  lineHeight="1.6"
                >
                  Thank you for your purchase!
                </Text>

                <Text
                  fontSize={FontSizes.Regular}
                  margin="0 0 25px 0"
                  lineHeight="1.6"
                  color="#666"
                >
                  You will receive the video link via email after the event.
                </Text>

                <SuccessButtonContainer>
                  <Button
                    onClick={handleBackToProduct}
                    width="100%"
                    height="50px"
                    fontSize={FontSizes.Regular}
                  >
                    Back Home
                  </Button>
                </SuccessButtonContainer>
              </SuccessContainer>
            ) : (
              <>
                <ProductImage>
                  <VideoIcon 
                    src="https://storage.googleapis.com/ticketing-files/events-products/klouterwoud-movie-p.jpg" 
                    alt="Concert Video"
                  />
                </ProductImage>

                <Text
                  fontSize={FontSizes.Big}
                  fontFamily={FontFamilies.Bold}
                  margin="0 0 15px 0"
                >
                  Order Your Concert Video
                </Text>

                <Text
                  fontSize={FontSizes.Regular}
                  margin="0 0 10px 0"
                  lineHeight="1.6"
                >
                  The concert will be professionally filmed.
                </Text>

                <Text
                  fontSize={FontSizes.Regular}
                  margin="0 0 20px 0"
                  lineHeight="1.6"
                >
                  The video link will be shared via email after the event.
                </Text>

                <PriceContainer>
                  <PriceText>R150</PriceText>
                </PriceContainer>

                {!showForm ? (
                  <ButtonContainer>
                    <Button
                      onClick={handleBuyNow}
                      width="100%"
                      height="50px"
                      fontSize={FontSizes.Regular}
                    >
                      Buy Now
                    </Button>
                  </ButtonContainer>
                ) : (
                  <FormContainer>
                    <Text
                      fontSize={FontSizes.Regular}
                      fontFamily={FontFamilies.Bold}
                      margin="0 0 15px 0"
                    >
                      Enter your details to continue
                    </Text>

                    <TextInput
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={(value) => handleInputChange('firstName', value)}
                      width="100%"
                    />

                    <TextInput
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={(value) => handleInputChange('lastName', value)}
                      width="100%"
                    />

                    <TextInput
                      placeholder="Email Address"
                      type="email"
                      value={formData.email}
                      onChange={(value) => handleInputChange('email', value)}
                      width="100%"
                    />

                    <TextInput
                      placeholder="Klouterwoud Class of Child(ren)"
                      value={formData.gradeOfChildren}
                      onChange={(value) => handleInputChange('gradeOfChildren', value)}
                      width="100%"
                    />

                    <ButtonContainer>
                      <Button
                        onClick={handleBack}
                        backgroundColor={Theme.Button.Secondary.Background}
                        textColor={Colors.White}
                        width="100%"
                        height="50px"
                      >
                        Back
                      </Button>
                      <Button
                        onClick={handleSubmit}
                        width="100%"
                        height="50px"
                        fontSize={FontSizes.Normal}
                      >
                        Continue to Payment
                      </Button>
                    </ButtonContainer>
                  </FormContainer>
                )}
              </>
            )}
          </ProductCard>
        </Card>
      </ProductContainer>
    </Container>
  );
};

export const Product = withCommon(ProductUI, {
  showLoadingOnLoad: false
});
